<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields" style="padding:0px;">
      <h2>Sectorization Display</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <div class="fields__block">
          <div>
            <img [src]="imageSanitized" alt="sectorization display" style="width: -webkit-fill-available;" />
          </div>
          <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
            <label for="sectorizationSlider" >Altitude Range</label>
            <ngx-slider
              [(value)]="sliderValue"
              [options]="sliderOptions"
              (userChangeEnd)="onSliderChange($event)"
            >
            </ngx-slider>
            <span>({{selectedRangeMin}}; {{selectedRangeMax}}) feet</span>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline;">
            <div>
              <label for="defaultDOC">Default DOC</label>
              <span id="defaultDOC">{{ this.defaultDoc }} NM</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

